export class AngularWebsiteCoreIoCKeys {
    //IoCContainer
    public static IAngularWebsiteCoreIoCContainer: string =
        'IAngularWebsiteCoreIoCContainer';

    public static IExtendedCookieService: string = 'IExtendedCookieService';
}
